import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
interface LabeledValueProps {
  label: string;
  value?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}
export default function LabeledValue(t0) {
  const $ = _c(11);
  const {
    label,
    value,
    icon,
    className
  } = t0;
  if (!value && value !== 0) {
    return null;
  }
  let t1;
  if ($[0] !== icon || $[1] !== label) {
    t1 = <span className="flex min-w-0 items-center gap-2 break-words text-overline text-muted-foreground [overflow-wrap:anywhere]">{icon}{label}</span>;
    $[0] = icon;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className) {
    t2 = cx("min-w-0 break-words text-body text-foreground", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== value) {
    t3 = <div className={t2}>{value}</div>;
    $[5] = t2;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="grid min-w-0 grid-cols-[9rem_1fr] items-start gap-3 py-2">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}